import { useI18n } from "vue-i18n";
import bus from "@/utils/bus";

/**
 * 统一的「联系我们 / 加企业微信入群」CTA 点击逻辑：
 * - 中文（zh-CN）：弹出企业微信二维码弹框（全局 ContactQrDialog 监听 bus 事件）
 * - 英文（en-US）：新标签页打开 HubSpot 预约链接（保持原行为）
 */
export function useContact() {
  const { t, locale } = useI18n();

  const openContact = (e?: Event) => {
    e?.preventDefault?.();
    if (locale.value === "zh-CN") {
      bus.emit("openContactQr");
    } else {
      window.open(t("common.bookingUrl"), "_blank");
    }
  };

  return { openContact };
}
